(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["wsjs"] = factory();
	else
		root["wsjs"] = root["wsjs"] || {}, root["wsjs"]["employee"] = factory();
})(self, function() {
return 